import React, { FC } from 'react'
import { Flex } from '../Flex/flex.component'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Typography } from '@mui/material';
import { Button } from '../Form/Button/button.scomponent';

interface IPlaceholderProps {
    description: string
    sx?: object
    Bottom?: () => JSX.Element
    textStyle?: object
    onRetry?: () => void
    retryLabel?: string
}

const Placeholder : FC<IPlaceholderProps> = ({
  description,
  Bottom,
  textStyle,
  onRetry,
  retryLabel = 'Tentar novamente',
  ...rest
}) => {
    return(
        <Flex flexDirection='column' alignItems='center' justifyContent='center' flex={1} {...rest}>
            <ErrorOutlineIcon fontSize='large' />
            <Typography marginTop='15px' sx={textStyle} >{description}</Typography>

            {onRetry && (
              <Button
                variant="outlined"
                onClick={onRetry}
                sx={{ mt: 2, minWidth: 160 }}
                textSx={{ textTransform: 'none', fontWeight: 600 }}
              >
                {retryLabel}
              </Button>
            )}

            {Bottom && <Bottom />}
        </Flex>
    )
}

export { Placeholder}